import styled from "styled-components";
import color from "../../assets/css/colors";
import { IContainerDelete } from "./interface";

export const ThirdCol = styled.div`
    width: 130px;
    position: relative;
`;

export const ProductImage = styled.img`
    width: 120px;
`

export const ContainerDelete = styled.div`
    display: ${(p: IContainerDelete) => p.isOpen ? "block" : "none"};
    position: absolute;
    cursor: pointer;
    top: 5px;
    right: 12px;
    border-radius: 50%;
    padding: 6px;
    background: ${color.grayLight};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;

    img {
        width: 18px;
    }
`